import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import "./BillingForm.scss";
import ArrowBack from '../../components/ArrowBack/ArrowBack';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getSuburbsByCp } from "../../utils/cities";
import ButtonBase from "../Buttons/ButtonBase";
import { createBillingLaywers } from "../../store/actions/billingAction";
import { validationBilling } from '../../utils/validations';
import axios from 'axios';
import MenuItem from '@material-ui/core/MenuItem';

import {CFDI} from '../../utils/Facturas/CFDI'

import {
    TextField
} from '@material-ui/core';


const useStyles = makeStyles(theme => ({

    inputLabelRoot: {
        transform: 'translate(14px, 16px) scale(1)',
    },
    formHelperTextRoot: {
        margin: '8px 14px',
        marginBottom: 0,
    },
    inputError: {
        border: '1px solid #d74242',
        '&:hover': {
            border: '1px solid #d74242',
        },
    },
    TextField: {
        maxWidth: '448px',
    },
    TextField_small: {
        maxWidth: '46%',
    },
}));


function sleep(delay = 0) {
    return new Promise((resolve) => {
      setTimeout(resolve, delay);
    });
  }
  


const BillingForm = (props) => {
    const { billing, membershipData } = props
    const classes = useStyles();
    const [flagLocation, setFlagLocation] = useState(false)
    const [location, setLocation] = useState({})
    const [neighborhoodData, setNeighborhoodData] = useState()
    const [laywerId, setLaywerId] = useState()
    const [valor, setvalor] = React.useState();

    const history = useHistory();

    useEffect(() => {
        setLaywerId(props.laywerUid);
    }, []);

    const handleBackData = () => {
        history.push('/dashboard/membresia')
    };

    const handleChange = (event) => {
        setvalor(event.target.value);
    };

    const handleZipCodeData = async () => {
        let location = await getSuburbsByCp(parseInt(billing.zipCode));
        setLocation(location);
    };

    const formBillingValues = {
        nameLawyerOrLawFirm: billing ? billing.nameLawyerOrLawFirm : "",
        rfc: billing ? billing.rfc : "",
        invoiceEmail:  billing ? billing.invoiceEmail : "",
        invoicePhoneNumber:  billing ? billing.invoicePhoneNumber : "",
        country: billing ? billing.country : "",
        zipCode: billing ? billing.zipCode : "",
        states: billing ? billing.states : "",
        city: billing ? billing.city : "",
        municipality: billing ? billing.municipality : "",
        neighborhood: billing ? billing.neighborhood : "",
        street: billing ? billing.street : "",
        outdoorNumber: billing ? billing.outdoorNumber : "",
        cfdi: billing ? billing.cfdi : [],
    };

    const handleSubmitBillingForm = async(values,{setFieldError}) => {
        console.log(values, 'values')

        if (values.zipCode == '' || values.zipCode == undefined) {
            values = { 
                ...values, 
                billingForm: true,
                country: "", 
                municipality: "", 
                neighborhood: "",
                outdoorNumber: "",
                street: "",
                city: "",
                states: "" 
            }
        } else {
            values = { 
                ...values, 
                billingForm: true, 
                country: "México", 
                municipality: location.municipio, 
                neighborhood: neighborhoodData === undefined ? billing.neighborhood : neighborhoodData,
                city: location.ciudad,
                states: location.estado
            }
        }
        
        if (values.city === undefined || values.city === null) {
            values['city'] = ''
        }
        if (values.municipality === undefined) {
            values['municipality'] = ''
        }
        if (values.states === undefined) {
            values['states'] = ''
        }
        props.createBillingLaywers(laywerId, values, setFieldError)
    }

    const handleGetStatesByZipCode = async (event, setFieldError) => {
        let location = await getSuburbsByCp(parseInt(event.target.value))
        console.log('location', location)
        if (!location) {
            setFieldError('zipCode', 'error')
            setFlagLocation(false);
        } else {
            setLocation(location);
            setFlagLocation(true);
        }
    }

    const selectNeighborhood = (params) => {
        setNeighborhoodData(params)
    }

    const handleRenderForm = (props) => {

        const { handleChange, handleSubmit, values, touched, errors, handleBlur, isValid,setFieldError } = props;

        console.log('values in payments', values);
        console.log('errors in payments', errors);

        return (
            <div className="contentMainBillingForm">
                <div className="contentTitle">
                    <p className="titleBilling"> Ayúdanos a llenar tus datos </p>
                    <p className="subTitleBilling">Estos datos se verán reflejados en tu factura</p>
                </div>
                <form>
                    <TextField
                        label="Nombre del abogado o despacho*"
                        name="nameLawyerOrLawFirm"
                        type="text"
                        variant="outlined"
                        onBlur={handleBlur}
                        value={values.nameLawyerOrLawFirm}
                        onChange={handleChange}
                        helperText={
                            touched.nameLawyerOrLawFirm && errors.nameLawyerOrLawFirm ? errors.nameLawyerOrLawFirm : ''
                        }
                        error={touched.nameLawyerOrLawFirm && errors.nameLawyerOrLawFirm ? true : false}
                        fullWidth
                        classes={{ root: classes.TextField }}
                    />
                    <TextField
                        label="RFC*"
                        name="rfc"
                        type="text"
                        variant="outlined"
                        value={values.rfc}
                        onInput={(e) => { e.target.value = e.target.value.toUpperCase() }}
                        inputProps={{ maxLength: 14 }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        helperText={
                            touched.rfc && errors.rfc ? errors.rfc : ''
                        }
                        error={touched.rfc && errors.rfc ? true : false}
                        fullWidth
                        classes={{ root: classes.TextField }}
                    />
                    <TextField
                        id="cfdi"
                        name="cfdi"
                        select
                        fullWidth
                        label="Uso de CFDI*"
                        variant="outlined"
                        classes={{ root: classes.TextField }}
                        value={values.cfdi}
                        onChange={handleChange}
                        helperText={
                            touched.cfdi && errors.cfdi ? errors.cfdi : ''
                        }
                        error={touched.cfdi && errors.cfdi ? true : false}
                    >
                        {CFDI.map((option) => (
                            <MenuItem key={option.code} value={option}>
                            {option.description}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Correo electrónico (donde deseas recibir la factura)*"
                        name="invoiceEmail"
                        type="text"
                        variant="outlined"
                        value={values.invoiceEmail}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        helperText={
                            touched.invoiceEmail && errors.invoiceEmail ? errors.invoiceEmail : ''
                        }
                        error={touched.invoiceEmail && errors.invoiceEmail ? true : false}
                        fullWidth
                        classes={{ root: classes.TextField }}
                    />
                    <TextField
                        label="Número telefónico"
                        name="invoicePhoneNumber"
                        type="text"
                        variant="outlined"
                        value={values.invoicePhoneNumber}
                        onBlur={handleBlur}
                        onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
                        inputProps={{minLength: 8, maxLength: 10 }}
                        onChange={handleChange}
                        helperText={
                            touched.invoicePhoneNumber && errors.invoicePhoneNumber ? errors.invoicePhoneNumber : ''
                        }
                        error={touched.invoicePhoneNumber && errors.invoicePhoneNumber ? true : false}
                        fullWidth
                        classes={{ root: classes.TextField }}
                    />
                    
                    <div className="containerTwoInput">
                        <TextField
                            label="País"
                            name="country"
                            type="text"
                            disabled={true}
                            variant="outlined"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={"México"}
                            fullWidth
                            classes={{ root: classes.TextField_small }}
                        />
                        <TextField
                            label="Código postal"
                            name="zipCode"
                            type="text"
                            variant="outlined"
                            value={values.zipCode}
/*                             onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
 */                          inputProps={{ maxLength: 5 ,  minLength: 5}}
                            onBlur={(event)=>handleGetStatesByZipCode(event,setFieldError)}
                            onChange={(event)=>{
                                handleChange(event)
                                if(event.target.value == ''){
                                    setLocation({});
                                }
                              }}
                            helperText={
                                touched.zipCode && errors.zipCode ? 'Error en CP' : ''
                            }
                            error={touched.zipCode && errors.zipCode ? true : false}
                            fullWidth
                            classes={{ root: classes.TextField_small }}
                        />
                    </div>
                    <div className="containerTwoInput">
                        <TextField
                            label={!flagLocation ? "Estado" : "Estado"}
                            name="states"
                            type="text"
                            variant="outlined"
                            value={location && location.estado ? location.estado : '' }
                            onBlur={handleBlur}
                            onChange={handleChange}
                            fullWidth
                            disabled={!flagLocation}
                            classes={{ root: classes.TextField_small }}
                        />
                        <TextField
                            label={!flagLocation ? "Ciudad" : "Ciudad"}
                            name="city"
                            type="text"

                            variant="outlined"
                            value={location && location.ciudad ? location.ciudad : ''}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            fullWidth
                            disabled={!flagLocation}
                            classes={{ root: classes.TextField_small }}
                        />

                    </div>
                    <div className="containerTwoInput">
                        <TextField
                            label={!flagLocation ? "Municipio" : "Municipio"}
                            name="municipality"
                            type="text"
                            variant="outlined"
                            disabled={!flagLocation}
                            value={location &&  location.municipio ? location.municipio : '' }
                            onBlur={handleBlur}
                            onChange={handleChange}
                            fullWidth

                            classes={{ root: classes.TextField_small }}
                        />
                        <Autocomplete
                            name="neighborhood"
                            options={location.colonias ? location.colonias : []}
                            getOptionLabel={(option) => option}
                            style={{ width: "45%" }}
                            onChange={(event, newValue) => {
                                selectNeighborhood(newValue);
                            }}
                            disabled={!flagLocation}
                            renderInput={(params) => <TextField
                                {...params}
                                value={neighborhoodData && billing.neighborhood && neighborhoodData === undefined ? billing.neighborhood : ''}
                                label="Colonia"
                                type="text"
                                variant="outlined"
                                fullWidth
                            />}
                        />

                    </div>
                    <div className="containerTwoInput">
                        <TextField
                            label="Calle"
                            name="street"
                            type="text"
                            variant="outlined"
                            value={values.street}
                            onBlur={handleBlur}
                            disabled={!flagLocation}
                            onChange={handleChange}
                            helperText={
                                touched.street && errors.street ? errors.street : ''
                            }
                            error={touched.street && errors.street ? true : false}
                            fullWidth
                            classes={{ root: classes.TextField_small }}
                        />
                        <TextField
                            label="No."
                            name="outdoorNumber"
                            type="text"
                            variant="outlined"
                            value={values.outdoorNumber}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            disabled={!flagLocation}
                            helperText={
                                touched.outdoorNumber && errors.outdoorNumber ? errors.outdoorNumber : ''
                            }
                            error={touched.outdoorNumber && errors.outdoorNumber ? true : false}
                            fullWidth
                            classes={{ root: classes.TextField_small }}
                        />

                    </div>

                       
                    <ButtonBase style={{marginTop: 15}}
                        type="submit"
                        onClick={handleSubmit}
                        className="buttonNext"
                        variant="primary"
                        disabled={!isValid}
                    >
                        Siguiente
                    </ButtonBase>

                </form>

            </div>
        )
    }
    return (
        <Formik
            initialValues={formBillingValues}
            validationSchema={validationBilling}
            onSubmit={handleSubmitBillingForm}
            render={handleRenderForm}
        />
    );
};

const mapDispatchToProps = dispatch => ({
    createBillingLaywers: (laywerUid, data,setFieldError) => dispatch(createBillingLaywers(laywerUid, data,setFieldError)),
})

const mapStateToProps = (state) => ({
    laywerUid: state.authClient.uid,
    modalPayments: state.ModalReducer.openModalPayments,
    role: state.authClient.role,
    billing: state.billingReducer.billingData,
    membershipData: state.authClient.membershipData ? state.authClient.membershipData :false
});

export default connect(mapStateToProps, mapDispatchToProps) (BillingForm);

